import { Role } from '../../../core/models/entities/Role'

export function isAllowed(active: Role, needed: Role): boolean {
  return active >= needed
}